<template>
  <div
    class="flex items-center justify-center w-full relative"
    :class="classes"
    :style="styles"
  >
    <transition name="fade" mode="out-in">
      <div v-show="loaded && !error" class="absolute inset-0">
        <img
          :src="src"
          @load="onLoaded"
          @error="onError"
          draggable="false"
          class="object-contain"
          :class="classes"
          :style="styles"
        />
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div v-show="!loaded && !error" class="absolute inset-0">
        <tw-spinner
          :class="classes"
          :style="styles"
        />
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div v-show="error" class="absolute inset-0 flex flex-col items-center justify-center">
        <icon-error size="36" class="text-white mb-2" />
        <span class="text-white font-medium">Image unavailable.</span>
      </div>
    </transition>
  </div>
</template>

<script>
import TwSpinner from "@/components/Tailwind/TwSpinner";
import IconError from "@/components/Icon/IconError";

export default {
  name: "TwImage",
  components: {IconError, TwSpinner },
  props: {
    src: {
      type: String,
      required: true
    },
    width: {
      default: "full"
    },
    height: {
      default: "auto"
    },
    aspectRatio: {
      default: "",
      required: false
    },
    noBackgroundColor: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      loaded: false,
      error: false
    };
  },
  computed: {
    styles() {
      return {
        'aspect-ratio': (this.aspectRatio === "" ? "unset" : this.aspectRatio)
      };
    },
    classes() {
      let classes = ['w-' + this.width, 'h-' + this.height];
      if (!this.noBackgroundColor) classes.push("bg-gray-300")
      return classes;
    }
  },
  mounted() {
    setTimeout(() => {
      if(!this.loaded) {
        this.onError();
      }
    }, 15000);
  },
  methods: {
    onLoaded() {
      this.loaded = true;
    },
    onError() {
      this.error = true;
    }
  }
}
</script>